import { faCity } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import VSpace from "../common/VSpace"

const SelectTenantView = () => {
  return <div id="main" className="main-template has-elements fluid-container">
    <div className="overlay">
      <VSpace size="large">
        <FontAwesomeIcon icon={faCity} size="3x" />
        <span>SELECT A TENANT</span>
      </VSpace>
    </div>
  </div>
}

export default SelectTenantView